import styled from 'styled-components';
import ScreenAnimation from '../../assets/styles/Screen.module.css';

interface Props {
	blurred: boolean;
}

const Screen = styled.div.attrs<Props>((props) => ({
	className: props.blurred ? ScreenAnimation.blurred : ScreenAnimation.clear
}))<Props>`
	bottom: 0;
	left: 0;
	right: 0;
	top: 0;
	position: absolute;
`;

export default Screen;
